import { useState } from 'react'
import { Link, RouteComponentProps } from 'react-router-dom'
import { Sparks } from './sparks'
// import { Sparks } from './sparks'

export default function Home({}: RouteComponentProps) {
  const [anmition, setAnmition] = useState(false)
  const [isActive, setIsActive] = useState(false)

  return (
    <>
      <section className="hero-section" id="home">
        <div className="container">
          <div className="row">
            <div className="col-md-7">
              <div className="row h-100">
                <div className="col-md-12 align-self-center">
                  <div className="hero-content">
                    <h1>META</h1>
                    <h2>INVISIBLE</h2>
                    <h3>CLOAK</h3>
                    <p>NFT Meta Cloak that makes you invisible in the metaverse</p>
                    <div className="btn-group">
                      <Link to="/buy" className="btn">
                        BUY NOW
                      </Link>
                      <Link to="/referral" className="btn">
                        SHARE
                      </Link>
                    </div>
                  </div>
                  <div className="row d-inline">
                    <a href="https://instagram.com/metainvisiblecloak?igshid=YmMyMTA2M2Y=">
                      <img className="icons" src="/img/instagram-social-icon@2x.png" />{' '}
                    </a>
                    <a href="https://twitter.com/metainvisible">
                      <img className="icons" src="/img/twittericon@2x.png" />
                    </a>
                    <a href="https://opensea.io/MetaInvisibleCloak">
                      <img className="icons" src="/img/opensea-social-icon@2x.png" />
                    </a>
                  </div>
                </div>
              </div>
            </div>
            <div className="col-md-5">
              <div className="row justify-content-center text-center">
                <div className="col-md-auto col-sm-auto">
                  <div className="hero-app-mock">
                    <img src="img/main-section-img.png" className="main-img" alt="" />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      <section className="inv-sec">
        <div className="container">
          <div className="row">
            <div className="col-md-6 valign mb-3">
              <div className="title">
                <h3>
                  EVER WANTED TO BECOME <b>INVISIBLE IN A PUSH OF A BUTTON?</b>
                </h3>
                <p>
                  That may soon become a reality in the Metaverse but why do you want to become invisible in the
                  Metaverse? The invisible function is for people who want to interact with people in the Metaverse but
                  who doesn't want to participate in social activities.
                  <br />
                  <br /> In other words, you can sneak up on other people and hear what they are talking about, maybe
                  they talk behind your back or about a secret innovation? Explore the Metaverse completely invisible at
                  the push of a button and choose between 'speak' and 'speakless' mode when you are invisible.
                </p>
                <div className="d-flex justify-content-center justify-content-md-start">
                  <style
                    dangerouslySetInnerHTML={{
                      __html:
                        "\n                            .photo-anmition {\n                                background-size: contain;\n                                background-repeat: no-repeat;\n                            }\n\n                            .photo-anmition-1 {\n                                animation-name: move2;\n                                animation-fill-mode: forwards;\n                                animation-duration: 1.5s;\n                            }\n\n                            .photo-anmition-2 {\n                                animation-name: move;\n                                animation-fill-mode: forwards;\n                                animation-duration: 1.5s;\n                            }\n\n                            @keyframes move {\n                                from {\n                                    background-image: url('img/sec2-img.png');\n                                }\n\n                                to {\n                                    background-image: url('img/sec1-img.png');\n                                }\n                            }\n\n                            @keyframes move2 {\n                                from {\n                                    background-image: url('img/sec1-img.png');\n                                }\n\n                                to {\n                                    background-image: url('img/sec2-img.png');\n                                }\n                            }\n                        ",
                    }}
                  />
                  <div id="switch" className="switch" onClick={() => setIsActive(!isActive)}>
                    <input type="checkbox" name="toggle" />
                    <label>
                      <span className="position-absolute off">0FF</span>
                      <span className="position-absolute on"> ON</span>
                      <i className="bulb">
                        <span className="bulb-center"></span>
                        <span className="filament-1"></span>
                        <span className="filament-2"></span>
                        <span className="reflections">
                          <span></span>
                        </span>

                        <span className="sparks">
                          <i className="spark1"></i>
                          <i className="spark2"></i>
                          <i className="spark3"></i>
                          <i className="spark4"></i>
                        </span>
                      </i>
                    </label>
                  </div>
                </div>
              </div>
            </div>
            {/* {isActive ? sparks : ''} */}
            {isActive ? (
              <Sparks active={isActive} />
            ) : (
              <div id="sparkss" className="col-12  position-relative col-md-6 photo-anmition photo-anmition-1">
                <img className="invisible" src="img/sec2-img.png" alt="" />
              </div>
            )}
          </div>
        </div>
      </section>
      <section className="two-crys-sec">
        <div className="container">
          <div className="row">
            <div className="col-md-6 mobile-hide">
              <img src="/img/2-crystals-img.jpg" alt="" />
            </div>
            <div className="col-md-6 valign">
              <div className="title">
                <h3>
                  POWERED BY TWO <br /> <b>SECRET MINERAL CRYSTAL </b>
                </h3>
                <p>
                  The invisible function is powered by two secret mineral crystals that are built inside the “MIC” Meta
                  Invisible Cloak coded within the fibre material that your avatar wears while in the metaverse and
                  because of that you are able to switch between 'visible' and 'invisible' mode. The secret mineral
                  crystals combined with an electric current from the push of a button creates a distortion field in the
                  Metaverse dimension which makes your avatar completely invisible to others.
                </p>
                <Link to="buy" className="btn">
                  BUY NOW
                </Link>
              </div>
            </div>
            <div className="col-md-6 mobile-show">
              <img src="/img/2-crystals-img.png" alt="" />
            </div>
          </div>
        </div>
      </section>
      <section className="activate-inv-sec" id="feature">
        <div className="container">
          <div className="row justify-content-center text-center">
            <div className="col-md-12">
              <div className="title">
                <h3>
                  ACTIVATING THE <b>INVISIBLE FEATURES</b>
                </h3>
                <p>
                  To activate the Meta Invisible cloak in the metaverse your MetaMask wallet must contain 1x Meta
                  Invisible Cloak NFT &amp; 2x Secret mineral Crystal NFT’s to unlock all the cloaks utilities.{' '}
                </p>
              </div>
            </div>
            <div className="col-md-12">
              <div className="row justify-content-md-center justify-content-sm-center">
                <div className="col-md-12">
                  <img src="/img/activate-cloak.png" data-aos="fade-up" alt="" />
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      <section className="opensea-sec">
        <div className="container">
          <div className="row">
            <div className="col-md-7 mobile-hide">
              <img src="/img/opensea-img.jpg" alt="" />
            </div>
            <div className="col-md-5 valign">
              <div className="title">
                <h3>
                  REMAINING CRYSTAL <b>WILL BE AVAILABLE ON OPENEA.IO</b>
                </h3>
                <p>
                  All remaining crystals not acquired through referral’s will be put up for sale on opensea public
                  market at floor price of 1.00 ETH all collected funds off crystals will go to MIC vault for further
                  project development.
                </p>
                <a href="https://opensea.io/MetaInvisibleCloak" className="btn">
                  BUY ON OPENSEA.IO
                </a>
              </div>
            </div>
            <div className="col-md-7 mobile-show">
              <img src="/img/opensea-img.jpg" alt="" />
            </div>
          </div>
          <div className="row justify-content-center mt-c-5">
            <div className="col-md-3">
              <div className="mic-card">
                <span>TOTAL SUPPLY</span>
                <h1>
                  25,000 <br /> MIC TOKENS
                </h1>
              </div>
            </div>
            <div className="col-md-3">
              <div className="mic-card">
                <span>REFERRAL</span>
                <h1>
                  REFER 2 PEOPLE TO <br /> BUY 1 MIC TOKEN
                </h1>
              </div>
            </div>
            <div className="col-md-3">
              <div className="mic-card">
                <span>REWARDS</span>
                <h1>
                  RECEIVE 2 FREE <br /> CHARGE CRYSTALS
                </h1>
              </div>
            </div>
            <div className="col-md-3">
              <div className="mic-card">
                <span>TOTAL SUPPLY</span>
                <h1>
                  50,000 <br /> CHARGE CRYSTALS
                </h1>
              </div>
            </div>
          </div>
        </div>
      </section>
      <section className="anti-grav-sec">
        <div className="container">
          <div className="row">
            <div className="col-md-6 valign">
              <div className="title">
                <h3>
                  ANTI-GRAVITY <b>SIMULATION</b>
                </h3>
                <p>
                  Development team is in discussions of possible anti gravity simulation abilities while running through
                  the metaverse. Maybe we release more info to the community about this as development progresses closer
                  to finish.{' '}
                </p>
                <a href="#" className="btn">
                  COMING SOON
                </a>
              </div>
            </div>
            <div className="col-md-6 ">
              <img src="/img/anti-gravity-img.png" alt="" />
            </div>
          </div>
        </div>
      </section>
      <section className="minting-sec">
        <div className="container">
          <div className="row">
            <div className="col-md-7 mobile-hide">
              <img src="/img/token-mint-img.jpg" alt="" />
            </div>
            <div className="col-md-5 valign">
              <div className="title">
                <h3>
                  META INVISIBLE CLOAK <br />
                  <b>MINT TOKENS</b>
                </h3>
                <p>
                  The invisible MIC cloak is of course not easy to develop, we are already a quarter into the
                  development and are racing to be the first team to release such technology live in the Metaverse. So
                  MIC has decided to help secure our position as first inventors and to help with the development costs
                  &amp; community building. MIC will be releasing MIC Mint tokens. Each token is a mint pass for 1 x
                  Meta Invisible Cloak NFT.
                </p>
              </div>
            </div>
            <div className="col-md-7 mobile-show">
              <img src="/img/token-mint-img.jpg" alt="" />
            </div>
          </div>
        </div>
      </section>
      <section className="mic-club-sec" id="feature">
        <div className="container">
          <div className="row justify-content-center">
            <div className="col-md-12">
              <div className="title">
                <h3>
                  HOW ABOUT A SECRET BASE IN THE METAVERSE{' '}
                  <b>
                    {' '}
                    <br />
                    ONLY ACCESSIBLE TO MIC CLOAK HOLDERS?
                  </b>
                </h3>
                <p>
                  Now think of a team gathering or community team parties in the metaverse but no one can see the 25,000
                  people live in one place except the MIC holder themselves. Caring both crystal shards will unlock
                  features like a switch between invisible to everyone or invisible to everyone excluding - Meta
                  invisible Cloak holders. Awesome way to tag team in the metaverse lowkey with your buddies.
                </p>
              </div>
            </div>
          </div>
        </div>
        <div className="col-md-12">
          <div className="app-mock-up-img">
            <div className="row justify-content-md-center justify-content-sm-center">
              <img src="/img/mic-club-img.jpg" alt="" />
            </div>
          </div>
        </div>
      </section>
    </>
  )
}
